import Vue from 'vue';
import gql from 'graphql-tag';

export default {
    namespaced: true,
    state: {
        paymentTypes: {},
        paymentTypesConfiguration: {},
        paymentTypeSelected: null,
        paymentTypeConfigurationLoaded: false,
        error: null,
        loading: false,
        paymentProcessing: false,
        paymentSummary: false,
    },
    getters: {
        getPaymentTypeSelected: state => state.paymentTypeSelected,
        calculateOrderPaymentFee: () => (total, paymentFee) => {
            let value = parseFloat(paymentFee.replace(/[^\d\.]*/g, ''));
            const isNegative = paymentFee.includes('-');
            if (paymentFee.includes('%')) {
                value = (total * value) / 100;
            }
            if (isNegative) {
                value = value * -1;
            }
            return value;
        },
    },
    mutations: {
        addPaymentType(state, paymentType) {
            if (paymentType.indexname && paymentType.label && paymentType.vueJsComponent) {
                Vue.set(state.paymentTypes, paymentType.indexname, paymentType);
            }
        },
        setPaymentTypesConfiguration(state, paymentTypesConfiguration) {
            Vue.set(state, 'paymentTypesConfiguration', paymentTypesConfiguration);
            Vue.set(state, 'paymentTypeConfigurationLoaded', true);
        },
        setPaymentTypeSelected(state, value) {
            state.paymentTypeSelected = value;
        },
        setError(state, value) {
            state.error = value;
        },
        setLoading(state, value) {
            state.loading = value;
        },
        setPaymentProcessing(state, value) {
            state.paymentProcessing = value;
        },
        setPaymentSummary(state, value) {
            state.paymentSummary = value;
        },
    },
    actions: {
        loadAllowedPayments({ state, commit }, options) {
            if (state.paymentProcessing && state.paymentTypeConfigurationLoaded) {
                commit('setLoading', false);
                return true;
            }
            commit('setLoading', true);
            Vue.$graphql
                .query({
                    query: gql`
                        query getPaymentTypesConfiguration(
                            $order: JSON
                            $country: String!
                            $basketTotal: Float
                            $differentShippingAddress: Boolean!
                            $pickupShipping: Boolean!
                        ) {
                            getPaymentTypesConfiguration(
                                order: $order
                                country: $country
                                basketTotal: $basketTotal
                                differentShippingAddress: $differentShippingAddress
                                pickupShipping: $pickupShipping
                            ) {
                                indexname
                                isActive
                                countries
                                position
                            }
                        }
                    `,
                    fetchPolicy: 'no-cache',
                    variables: {
                        order: {
                            position: 'ASC',
                        },
                        ...options,
                    },
                })
                .then(r => r.data.getPaymentTypesConfiguration)
                .then(data => {
                    const paymentTypesConfiguration = {};
                    for (const paymentTypeConfiguration of Object.values(data)) {
                        paymentTypesConfiguration[paymentTypeConfiguration.indexname] = paymentTypeConfiguration;
                    }
                    commit('setPaymentTypesConfiguration', paymentTypesConfiguration);
                    commit('setLoading', false);
                });
        },
    },
};
